import {
  type DefaultOptions,
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { type PropsWithChildren, useState } from 'react';
import { useSnackbar } from 'notistack';

import { getUserMessage } from '@/utils/error';

type ApiMutationMeta = {
  showUserMessage?: boolean;
  defaultUserMessage?: string;
};

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  },
  mutations: {
    retry: false,
  },
};

export const ApiQueryProvider = ({ children }: PropsWithChildren) => {
  const { enqueueSnackbar } = useSnackbar();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions,
        mutationCache: new MutationCache({
          onError: (error, _variables, _context, mutation) => {
            const meta = mutation.meta as ApiMutationMeta | undefined;

            if (meta?.showUserMessage === false) {
              return;
            }

            enqueueSnackbar(getUserMessage(error, meta?.defaultUserMessage), {
              variant: 'error',
            });
          },
        }),
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
